import React, { useContext, useEffect, useState, useCallback, useRef } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import CanvasContext from '../../../context/CanvasContext';
import socket from './../../../socket'
import AuthContext from '../../../context/AuthContext';
import styles from './styles/ClassroomCanvasSidebar.module.css';
import axios from 'axios';
import { FaCircle, FaUserSlash, FaFile, FaMousePointer, FaComment, FaChevronDown } from 'react-icons/fa';

const ClassroomCanvasSidebar = ({ activeStudents, selectedUserPropFunction }) => {
    const {
        selectedNodeId,
        assignmentWithSubmissions,
        highlightSubmission,
        nodes,
        edges,
        onCanvasClick,
        resetHighlightSubmission,
    } = useContext(CanvasContext);
    
    const [selectedNodeWork, setSelectedNodeWork] = useState({ workData: [], choiceLabelMap: new Map() }); // Custom object state!
    const [currentSelectedStudent, setCurrentSelectedStudent] = useState(null); // New state varaible to replace the "let" definition
    const [selectedStudentSubmissions, setSelectedStudentSubmissions] = useState([]);
    
    // useEffect(() => {    
    //     const fetchData = async () => {
    //         try {
    //             const res = await axios.get(`${process.env.REACT_APP_API_URL_LOCAL}/api/situations/choices/${selectedNodeId}`);
    //             const data = await res.json(); 

    //             const tempWork = [];
    //             if(assignmentWithSubmissions !== 'undefined' && assignmentWithSubmissions.submissions !== 'undefined'){
    //             assignmentWithSubmissions.submissions.forEach(submission => {
    //                 const { decisions, viewer } = submission;

    //                 for (let i = 0; i < decisions.length; i++) {
    //                     const decision = decisions[i];

    //                     if (decision.type === 'situation' && decision.id === data._id) {
    //                         const groupSubmit = [];
    //                         for (let j = 0; j < decisions.length; j++) {
    //                             const next = decisions[j];

    //                             const match = data.choices.find(choice => choice._id === next.id);
    //                             if (match) {
    //                                 groupSubmit.push({ viewer, nodeInfo: next })
    //                             }
    //                         }
    //                         tempWork.push(groupSubmit);
    //                         break;
    //                     }
    //                 }
    //             });
    //             setSelectedNodeWork(tempWork);
    //         }
    //         } catch (err) {
    //             console.error('Fetch or parse error:', err);
    //         }
    //     };

    //     if (selectedNodeId) {
    //         fetchData();
    //     }
    // }, [selectedNodeId, assignmentWithSubmissions]);


    /**
     * REFACTOR SUMMARY:
     * This effect now processes local data from context instead of making a network request.
     *
     * 1.  The `axios.get` call has been eliminated. We now use `nodes` and `edges` from the
     *     `CanvasContext`. All the data is already accessible there, no need to make an extra axios request!!
     *     We now generate the set of valid choice IDs by filtering the `edges` array for any edge whose `source` matches the `selectedNodeId`.
     *
     * 2.  Fix of the "key" warning. The primary logic was changed to group all relevant decisions by viewer (`student`)
     *     instead of by submission. This aggregates a student's work and ensures that each rendered `div`
     *     in the JSX has a unique `viewer._id` as its key, resolving the React warning. We use a Map for efficient grouping.
     *
     * 3.  A `choiceLabelMap` is created from the `edges` data. This allows for an efficient O(1)
     *     lookup of the correct choice title (`edge.data.label`) when rendering, rather than searching through arrays.
     *
     * 4.  Added checks to ensure `nodes` and `edges` are available before processing. This is always good to do!
     */
    useEffect(() => {
        const processNodeWork = () => {
            if (!selectedNodeId || !nodes || !edges || !assignmentWithSubmissions?.submissions) {
                // FIX: Reset the state to its correct object shape, not an array.
                setSelectedNodeWork({ workData: [], choiceLabelMap: new Map() });
                return;
            }

            const relevantChoices = edges.filter(edge => edge.source === selectedNodeId);
            const relevantChoiceIds = new Set(relevantChoices.map(edge => edge.id));
            const choiceLabelMap = new Map(relevantChoices.map(edge => [edge.id, edge.data.label]));

            // const workByViewer = new Map();

            // for (const submission of assignmentWithSubmissions.submissions) {
            //     const relevantDecisions = submission.decisions.filter(decision => relevantChoiceIds.has(decision.id));

            //     if (relevantDecisions.length > 0) {
            //         const viewerId = submission.viewer._id;
            //         if (!workByViewer.has(viewerId)) {
            //             workByViewer.set(viewerId, {
            //                 viewer: submission.viewer,
            //                 decisions: []
            //             });
            //         }

            //         const augmentedDecisions = relevantDecisions.map((decision, index) => ({
            //             ...decision,
            //             _uniqueKey: `${submission._id}-${decision.id}-${index}`
            //         }));
                    
            //         workByViewer.get(viewerId).decisions.push(...augmentedDecisions);
            //     }
            // }

            const workByViewer = new Map();

            for (const submission of assignmentWithSubmissions.submissions) {
                const viewerId = submission.viewer._id;
                const relevantDecisions = submission.decisions.filter(decision => relevantChoiceIds.has(decision.id));

                if (relevantDecisions.length > 0) {
                    const attemptGroup = {
                        submissionId: submission._id,
                        timestamp: submission.updatedAt,
                        decisions: relevantDecisions.map((decision, index) => ({
                            ...decision,
                            _uniqueKey: `${submission._id}-${decision.id}-${index}`
                        }))
                    };

                    if (!workByViewer.has(viewerId)) {
                        workByViewer.set(viewerId, {
                            viewer: submission.viewer,
                            attempts: []
                        });
                    }

                    workByViewer.get(viewerId).attempts.push(attemptGroup);
                }
            }

            //console.log(Array.from(workByViewer.values()));
            
            setSelectedNodeWork({
                workData: Array.from(workByViewer.values()),
                choiceLabelMap: choiceLabelMap
            });
        };

        processNodeWork();
    }, [selectedNodeId, assignmentWithSubmissions, nodes, edges]);

    
    
    // It's generally not good practice to have a mutable let variable outisde of the React's state. Better to have a state varaible for this.
    // let currentSelectedStudent = null;

    // const viewSubmissionWork = (student) => {
    //     currentSelectedStudent = student;
        
    //     if(assignmentWithSubmissions !== 'undefined' && assignmentWithSubmissions.length !== 0 && assignmentWithSubmissions.submissions !== 'undefined' && assignmentWithSubmissions.submissions.length !== 0){
    //         const dataSource = assignmentWithSubmissions?.submissions;
    //         if(dataSource){
    //             const filtered = dataSource.filter(log => {
    //                 return log.viewer._id == student.userId;
    //             })

    //             if(filtered.length !== 0){
    //                 const stuff = filtered.sort((a, b) => {
    //                     const d1 = new Date(a.updatedAt);
    //                     const d2 = new Date(b.updatedAt);
    //                     return new Date(b.updatedAt) - new Date(a.updatedAt);
    //                 })
    //                 highlightSubmission(stuff[0]);
    //             }
    //         }
    //     }
    // };

    /**
     * 1.  HOOK BEST PRACTICES (`useCallback`): Wrapping this function in `useCallback` ensures it isn't recreated
     *     on every render. This optimizes performance and allows it to be used safely in `useEffect` dependency arrays
     *     without causing infinite loops.
     *
     * 2.  STATE MANAGEMENT: The function now calls `setCurrentSelectedStudent` to update the component's state,
     *
     * 3.  Optional chaining (`?.`) is used to safely access nested properties on the
     *     `assignmentWithSubmissions` object. The logic for filtering and sorting is preserved but written more
     *     concisely.
     */
    const viewSubmissionWork = useCallback((student, selectedWhileActive) => {
        console.log("work", assignmentWithSubmissions);
        setCurrentSelectedStudent({student, selectedWhileActive});
        selectedUserPropFunction(student);

        const dataSource = assignmentWithSubmissions?.submissions;
        if (!dataSource || !student?.userId) return;

        const studentSubmissions = dataSource.filter(log => log.viewer._id === student.userId);

        console.log("Just a test log here to see if this is infinitely rendering cuz my browser CRASHED mannnn")

        if (studentSubmissions.length > 0) {
            const latestSubmissions = studentSubmissions.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
            
            setSelectedStudentSubmissions(latestSubmissions);
            
            if(student.startStatus){
                return;
            }
            
            highlightSubmission(latestSubmissions[0]);
        }
    }, [assignmentWithSubmissions, selectedStudentSubmissions, highlightSubmission]);

    // useEffect(() => {
    //     if(currentSelectedStudent != null && assignmentWithSubmissions !== 'undefined') {viewSubmissionWork(currentSelectedStudent);}
    // }, [assignmentWithSubmissions]);

    
    /**
     * 1.  Using the state variable in the dependency array now.
     * 2.  Can put viewsubmissionWork in here because of the useCallback
     */
    // useEffect(() => {
    //     if (currentSelectedStudent) {
    //         viewSubmissionWork(currentSelectedStudent);
    //     }
    // }, [assignmentWithSubmissions, currentSelectedStudent]); // I had to remove viewSubmissionWork from here otherwise it'd infinitely render

    const prevStudentSubmissionsRef = useRef('');

    useEffect(() => {
        //console.log("curr select student", activeStudents);
        if (!currentSelectedStudent || !assignmentWithSubmissions?.submissions) return;
        
        const searchActiveStudent = activeStudents.some(user => user.userId === currentSelectedStudent.student.userId);
        
        //If no longer an active student
        if(!searchActiveStudent && currentSelectedStudent.selectedWhileActive){
            resetHighlightSubmission();
            setCurrentSelectedStudent(null);
            selectedUserPropFunction(null);

            return;
        }

        const studentId = currentSelectedStudent.student.userId;
        const studentSubmissions = assignmentWithSubmissions.submissions.filter(
            (log) => log.viewer._id === studentId
        );

        const serialized = JSON.stringify(studentSubmissions);

        if (prevStudentSubmissionsRef.current !== serialized) {
            prevStudentSubmissionsRef.current = serialized;
            viewSubmissionWork(currentSelectedStudent.student, currentSelectedStudent.selectedWhileActive);
        }
    }, [assignmentWithSubmissions, currentSelectedStudent, activeStudents, viewSubmissionWork]);

    // return (
    //     <>
    //         <h2 className={styles.headerStyle}>Assignment View</h2>
    //         <div className={styles.sidebar}>
    //             {activeStudents.length === 0 ? (
    //                 <h4 className = {styles.subHeaderStyle}> 🔴 No active students</h4>
    //             ) : (activeStudents.map((student, index) => (
    //                 <div>
    //                     <h4 className={styles.subHeaderStyle} key={student.userId || index}> 🟢 Active Students</h4>
    //                     <button key={student.userId || `sub{index}`} onClick={() => viewSubmissionWork(student)}> {index+1} : {student.userName} ({student.userEmail})</button>
    //                 </div>
    //             )))}
    //         </div>

    //         <div>
    //             <h4 className={styles.subHeaderStyle}>Work:</h4>
    //             {selectedNodeWork.map((workGroup, index) => (
    //                 <div key={index} className = {styles.workTrackerStyle}>
    //                     {workGroup.length > 0 && (
    //                         <h4>{workGroup[0].viewer.username}'s Response:</h4>
    //                     )}
    //                     {workGroup.map((submitInfo, index1) => {
    //                         if (submitInfo.nodeInfo.type === 'choice') {
    //                             return (
    //                                 <p key={`${index}-${index1}`}>
    //                                     ➤ Chose: {submitInfo.nodeInfo.title}
    //                                 </p>
    //                             );
    //                         } else if (submitInfo.nodeInfo.type === 'input') {
    //                             return (
    //                                 <p key={`${index}-${index1}`}>
    //                                     ➤ Input: {submitInfo.nodeInfo.userInput}
    //                                 </p>
    //                             );
    //                         } else {
    //                             return null;
    //                         }
    //                     })}
    //                 </div>
    //             ))}
    //         </div>
    //     </>
    // );


    /**
     * 1.   React's `key` prop is now used correctly
     *      This should hopefully get the console to stop screaming at us.
     *
     * 2.   The "Active Students" header was previously repeated inside the `map` loop, causing it
     *      to render for every student. It has been moved outside the loop so it only renders once.
     *
     * 3.   Styling, yay...
     *
     * 4.   Added "No work submitted for this node yet." that renders when `selectedNodeWork` is empty. This is better UX than just showing nothing.
     *      The check for `workGroup.length > 0` was removed, as our refactored logic already ensures that
     *      only non-empty groups are included in `selectedNodeWork`.
     */

    return (
        <div className={styles.sidebarContainer}>
            <div className={styles.section}>
                <h2 className={styles.header}>Assignment View</h2>
                {activeStudents.length === 0 ? (
                    <div className={styles.emptyState}>
                        <FaUserSlash className={styles.emptyStateIcon} />
                        <h4>No Active Students</h4>
                        <p>No students are currently viewing the assignment.</p>
                    </div>
                ) : (
                    <>
                        <div className={styles.sectionHeader}>
                            <FaCircle className={styles.statusIconActive} />
                            <h4>Active Students</h4>
                        </div>
                        <div className={styles.studentList}>
                            {activeStudents.map((student, index) => (
                                student.startStatus ? (
                                    <button 
                                        key={student.userId} 
                                        className={`${styles.studentButton} ${currentSelectedStudent?.userId === student.userId ? styles.studentButtonSelected : ''}`}
                                        onClick={() => viewSubmissionWork(student, true)}
                                    >
                                        <span className={styles.studentIndex}>{index + 1}</span>
                                        <div className={styles.studentInfo}>
                                            <span className={styles.studentName}>{student.userName}</span>
                                            <span className={styles.studentEmail}>{student.userEmail}</span>
                                            <span>Inactive</span>
                                        </div>
                                        {/* <FaComment className={styles.activeUserMessaging}/>
                                        <FaChevronDown onClick={() => displaySubmissionDropdown(student)}/> */}
                                    </button>
                            ) : (
                                <button
                                    key={student.userId}
                                    onClick={() => viewSubmissionWork(student, true)}
                                    className={`${styles.studentButton} ${currentSelectedStudent?.userId === student.userId ? styles.studentButtonSelected : ''}`}
                                >
                                    <span className={styles.studentIndex}>{index + 1}</span>
                                    <div className={styles.studentInfo}>
                                        <span className={styles.studentName}>{student.userName}</span>
                                        <span className={styles.studentEmail}>{student.userEmail}</span>
                                    </div>
                                    {/* <FaComment className={styles.activeUserMessaging}/> */}
                                </button>
                                )
                            )
                            )}
                        </div>
                    </>
                )}
            </div>
            
            <div>
                <div className={styles.sectionHeader}>
                    <h4>All students</h4>
                </div>
                {assignmentWithSubmissions?.students ? (
                            assignmentWithSubmissions.students.map((student, index) => {
                                if(activeStudents.some(stud => stud.userId === student._id)){
                                    return (
                                        <div>
                                            <button onClick={() => viewSubmissionWork(activeStudents.find((stud) => stud.userId === student._id), false)} className={styles.studentButton} key={student._id}>{index+1} {student.username}</button>
                                        </div>
                                    )
                                }
                                else{
                                    return (
                                    <div>
                                        <button onClick={() => viewSubmissionWork({userId: student._id, userName: student.username, userEmail: student.userEmail, startStatus:true}, false)} className={styles.studentButton} key={student._id}>{index+1} {student.username}</button>
                                    </div>
                                        )
                                }   
                            })):(
                                <div>Loading</div>
                            )}
            </div>



            <div className={styles.section}>
                <div className={styles.sectionHeader}>
                    <h4>Submission Details</h4>
                </div>
                {!selectedNodeId ? (
                    <div className={styles.promptBox}>
                        <FaMousePointer className={styles.promptIcon} />
                        <h4>Select a Node</h4>
                        <p>Click a node on the canvas to view submissions.</p>
                    </div>
                ) : selectedNodeWork?.workData?.length > 0 ? (
                    <div className={styles.workDisplayContainer}>
                        {selectedNodeWork.workData.map((viewerWork) => (
                            <div key={viewerWork.viewer._id} className={styles.workCard}>
                                <h5 className={styles.workCardHeader}>{viewerWork.viewer.username}'s Response</h5>
                                <div className={styles.decisionList}>
                                    {viewerWork.attempts.map((attempt) => (
                                        <div className={`${styles.decisionList} ${styles.submissionGrouping}`}>
                                        {attempt.decisions.map((decisionInfo, index) => {
                                            if (decisionInfo.type === 'choice') {
                                            return (
                                                <p key={decisionInfo._uniqueKey} className={styles.decisionItem}>
                                                    <span className={styles.decisionLabel}>Chose:</span>
                                                    {selectedNodeWork.choiceLabelMap.get(decisionInfo.id) || 'Unknown Choice'}
                                                </p>
                                            );
                                        }
                                        if (decisionInfo.type === 'input') {
                                            return (
                                                <p key={decisionInfo._uniqueKey} className={styles.decisionItem}>
                                                    <span className={styles.decisionLabel}>Input:</span>
                                                    {decisionInfo.userInput}
                                                </p>
                                            );
                                        }
                                        return null;
                                        })}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className={styles.emptyState}>
                         <FaFile className={styles.emptyStateIcon} />
                        <h4>No Submission</h4>
                        <p>No work has been submitted for this node yet.</p>
                    </div>
                )}
            </div>

            {/* <div>
                {selectedStudentSubmissions.map((submission, index) => (
                    <div>
                        <button className={styles.studentButton} onClick={() => highlightSubmission(submission)}>{index+1} Submission</button>
                    </div>
                ))}
            </div> */}
        </div>
    );
}

export default ClassroomCanvasSidebar;

//Change the view submission to maybe be done by students in assignmentwithsubmissiosn rather than active students that will be best
//course of action but also reuiqres overhaul of assignmentwithsubmissions because activestudents doesnt have the same id's
//and some data is missing from assignmentwithsubmissioons.students versus what can be found in activestyudents